import { styled } from 'stitches.config'

export const HeroRoot = styled('div', {
  marginTop: '$8',
  px: '$12',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '2',
  color: '$accent-black',

  '@bp2': {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '0',
    marginTop: '$10',
  },
})

export const HeroImage = styled('figure', {
  width: '350px',
  height: '350px',
  flexShrink: 0,
  '&:last-of-type': {
    display: 'none',
  },

  '@bp3': {
    '&:last-of-type': {
      display: 'block',
    },
  },
})

export const Content = styled('div', {
  marginTop: '$1',
  maxWidth: '500px',
})
